// constants.js
export const Content =
    [
        "Company Name to be quoted",
        "Opportunity ID",
        "Opportunity Type",
        "Location of Buyer",
        "Partner/Resellers",
        "Broker/Consultant",
        "Broker Commission?",
        "Broker Commission (%)",
        "Total HC to be quoted",
        "Currency requested",

    ];


export const CheckboxLabels = [
    "Scheduled in-person sessions",
    "Scheduled video sessions",
    "Scheduled phone sessions",
    "Single Session Therapy",
    "Daily Living",
    "Child Care",
    "Elder Care",
    "Life Coaching",
    "Legal Research and Referral",
    "Computerized CBT (English only)",
    "Counseling Match To Insurance",
    "Aware (Mindfulness Program)",
    "Financial Research and Referral",
    "Member Website",
    "Manager Assist",
];

export const Constant = {
    FORM_HEADING: "Please continue by filling out the form now.",
    SAMPLE: "Sample CSV file",
    CRM_DATA: "CRM Data",
    ACCORDIAN_SUBTITLE: "Prefetched Data*",
    QUOTE_DETAILS: "Quote Details",
    ACCORDIAN_SUBTITLETWO: "All the fields are mandatory*",
    SECOND_ACCORDIAN_LABEL1: "Current number of lives served through the Partner/Reseller",
    TOOLTIP_TITLE1: "Even if they dont'ask; check the total headcount of the company (research online or simply ask them).Potenial volume impacts pricing consideration",
    SECOND_ACCORDIAN_LABEL2: "Total potential headcount outside what is requested to be quoted",
    SECOND_ACCORDIAN_LABEL3: "For formal RFP",
    IF_APPLICABLE: "(If applicable)",
    SECOND_ACCORDIAN_LABEL4: "Formal RFP Notes",
    SECOND_ACCORDIAN_LABEL5: "Name(s) of Competitors Bidding",
    SECOND_ACCORDIAN_LABEL6: "Past quotes",
    SECOND_ACCORDIAN_LABEL7: "Current Utilization with another vendor (If Applicable)",
    SECOND_ACCORDIAN_LABEL8: "Deadline",
    SECOND_ACCORDIAN_LABEL9: "Number of RAM(s)",
    SECOND_ACCORDIAN_LABEL10: "Location of RAM(s)",
    SECOND_ACCORDIAN_LABEL11: "SAM Pricing Recommendation and assumptions",
    SECOND_ACCORDIAN_LABEL12: "Product name",
    SECOND_ACCORDIAN_LABEL13: "Product variation",
    COMPONENTS: "Components",
    SESSION: "Session",
    UTILIZATION: "Utilization (%)",
    PRICING_STRUCTURE: "Pricing Structure",
    CALCULATE: "Calculate",
    UTILIZATION_DISTRIBUTION: "Utilization Distribution",
    EDIT: "Edit",
    PRICING_CALCULATION: "Pricing Calculation ",
    ALL_IN_PRICE: "(All in price)",
    PEPM: "PEPM",
    AUD1: "AUD 3.69",
    PEPM_USD: "PEPM-USD",
    AUD2: "AUD 3.69",
    GO_BACK: "Go Back",
    SAVE_DRAFT: "Save as Draft",
    SUBMIT_VIEW: "Submit Quote & View",
    OVERRIDE: "Override",
    CANCEL: 'Cancel',
    BANNER_PARAGRAPH: "Ready to get a personalized quote? Fill out the form to create a new quote request effortlessly. Let's start now",
}

